/**
 * Real-time NOAA RTMA 2.5km surface temperature observation raster layer.
 *
 * Ingests observed RTMA 2M surface temperature PMTiles grids, rendering
 * the continental analysis map with high-resolution topographic corrections.
 */

import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';
import { getTileUrl } from '../config';
import ManifestTimelineHelper from '../services/ManifestTimelineHelper';

export class HrtempCurrentLayer extends BaseProduct {
  public readonly id: ProductId = 'hrtemp_current';

  protected onActivate(): void {
    this.refresh();
  }

  protected onDeactivate(): void {
    this.layerManager.removeBufferedRasterLayer(this.id);
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh(): void {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const opacity = getLayerOpacity(this.id, 0.8);
    const current = state.currentTimeStep;
    if (!current) return;

    const model = 'rtma';
    let clampedFrame = ManifestTimelineHelper.getClampedFrame(manifest, 'hrtemp_current', model, current);
    if (!clampedFrame) {
      clampedFrame = ManifestTimelineHelper.getClampedFrame(manifest, 'hrtemp', model, current);
    }

    if (!clampedFrame) {
      this.layerManager.removeBufferedRasterLayer(this.id);
      return;
    }

    const dateStr = clampedFrame.dateStr;
    const hourStr = clampedFrame.hourStr.replace(/^Z/, '');

    const tiles = [
      getTileUrl(manifest, this.id, model, dateStr, hourStr)
    ];

    this.layerManager.updateBufferedRasterLayer(this.id, tiles, opacity, undefined, 0, 5);
  }
}

export default HrtempCurrentLayer;
